import { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import LoginPage from '@/pages/auth/LoginPage';
import DashboardPage from '@/pages/dashboard/DashboardPage';
import TenantsListPage from '@/pages/tenants/TenantsListPage';
import TenantDetailPage from '@/pages/tenants/TenantDetailPage';
import PlansListPage from '@/pages/plans/PlansListPage';
import PlanFormPage from '@/pages/plans/PlanFormPage';
import SettingsPage from '@/pages/settings/SettingsPage';
import EstadosHomologadosPage from '@/pages/mantenedores/EstadosHomologadosPage';
import CanalesCatalogPage from '@/pages/mantenedores/CanalesCatalogPage';
import EndpointsIntegracionPage from '@/pages/mantenedores/EndpointsIntegracionPage';
import { MainLayout } from '@/components/layout';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function App() {
  return (
    <Suspense
      fallback={
        <div className="min-h-screen flex items-center justify-center">
          <LoadingSpinner />
        </div>
      }
    >
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="tenants" element={<TenantsListPage />} />
          <Route path="tenants/:id" element={<TenantDetailPage />} />
          <Route path="plans" element={<PlansListPage />} />
          <Route path="plans/new" element={<PlanFormPage />} />
          <Route path="plans/:id" element={<PlanFormPage />} />
          <Route path="mantenedores" element={<Navigate to="/mantenedores/estados" replace />} />
          <Route path="mantenedores/estados" element={<EstadosHomologadosPage />} />
          <Route path="mantenedores/canales" element={<CanalesCatalogPage />} />
          <Route path="mantenedores/endpoints" element={<EndpointsIntegracionPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Suspense>
  );
}

export default App;
